import React, { useState, useEffect } from "react";
import axios from "../../services/api";
import { format } from "date-fns";
import { useToast } from "../../context/ToastContext";

const InvoiceList = () => {
  const [invoices, setInvoices]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteId, setDeleteId]   = useState(null);
  const { showToast }             = useToast();

  useEffect(() => { fetchInvoices(); }, []);

  const fetchInvoices = async () => {
    try {
      const res = await axios.get("/invoices");
      setInvoices(res.data || []);
    } catch (err) {
      console.error("Error fetching invoices:", err);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowConfirm(true);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`/invoices/${deleteId}`);
      showToast("success", "Deleted", "Invoice deleted successfully.");
      setShowConfirm(false);
      fetchInvoices();
    } catch (err) {
      console.error("Error deleting invoice:", err);
      showToast("error", "Failed", "Could not delete invoice.");
    }
  };

  return (
    <div>
      {/* ── Page header ── */}
      <div className="ims-page-header">
        <div>
          <h4>Invoices</h4>
          <p>Track vendor invoices linked to GRNs</p>
        </div>
      </div>

      {/* ── Table ── */}
      {loading ? (
        <div className="text-center py-5">
          <i className="fas fa-spinner fa-spin fa-2x text-primary"></i>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="ims-table">
            <thead>
              <tr>
                <th>Sr.</th>
                <th>Invoice #</th>
                <th>GRN ID</th>
                <th>Vendor</th>
                <th>Total Amount</th>
                <th>Invoice Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {invoices.length > 0 ? invoices.map((inv, i) => (
                <tr key={inv.id}>
                  <td>{i + 1}</td>
                  <td><strong>{inv.id}</strong></td>
                  <td>{inv.grn_id || "—"}</td>
                  <td>{inv.vendor_name}</td>
                  <td style={{ fontWeight: 600 }}>
                    ₹{parseFloat(inv.total_amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                  </td>
                  <td>
                    {inv.invoice_date
                      ? format(new Date(inv.invoice_date), "dd/MM/yyyy")
                      : "—"}
                  </td>
                  <td>
                    <button
                      className="ims-btn ims-btn-danger"
                      title="Delete Invoice"
                      onClick={() => confirmDelete(inv.id)}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="7" className="text-center text-muted py-4">No invoices found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* ── Delete Confirm Modal ── */}
      {showConfirm && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,.4)" }}>
          <div className="modal-dialog">
            <div className="modal-content shadow-lg" style={{ borderRadius: "12px", border: "none" }}>
              <div className="modal-header" style={{ borderRadius: "12px 12px 0 0" }}>
                <h5 className="modal-title" style={{ fontWeight: 700, color: "#991b1b" }}>
                  <i className="fas fa-trash mr-2"></i>Delete Invoice
                </h5>
                <button className="btn-close" onClick={() => setShowConfirm(false)}></button>
              </div>
              <div className="modal-body" style={{ fontSize: "13px" }}>
                Are you sure you want to delete Invoice <strong>#{deleteId}</strong>? This cannot be undone.
              </div>
              <div className="modal-footer">
                <button className="btn btn-sm btn-secondary" onClick={() => setShowConfirm(false)}>Cancel</button>
                <button className="btn btn-sm btn-danger" onClick={handleDelete}>
                  <i className="fas fa-trash mr-1"></i> Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvoiceList;
